var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"column-selector"},[_c('VSelect',{attrs:{"value":_vm.selectedColumn,"options":_vm.availableColumns,"placeholder":"Название","label":"label","track-by":"id"},on:{"input":_vm.onColumnSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }